//import { DEFAULT_STATE_OBJECT } from '@/utils/variables'

export default {
  OPEN_MODAL(state, { type, header, message, component, callback, closeCallback, btnName }) {
    if (state.open.hasOwnProperty(type)) {
      state.open[type] = true;
    }
    if (typeof header === 'string') {
      state.header = header;
    }
    if (typeof message === 'string') {
      state.message = message;
    }
    if (component) {
      state.component = component;
    }
    if (typeof callback === 'function') {
      state.callback = callback;
    }
    if (typeof closeCallback === 'function') {
      state.closeCallback = closeCallback;
    }
    state.btnName = {
      confirm: btnName?.confirm || '',
      close: btnName?.close || '',
    };
  },
  // header, message 등 모달 데이터를 동시에 쓰고 있으므로, 데이터 모달 위 다른 모달을 띄울 경우 필요.
  CLOSE_DATA_MODAL(state) {
    state.open.data = false;
    state.header = '';
    state.message = '';
    state.component = null;
  },
  CLOSE_MODAL(state) {
    for (let key in state.open) {
      state.open[key] = false;
    }
    setTimeout(() => {
      state.header = '';
      state.message = '';
      state.component = null;
      state.callback = null;
      state.closeCallback = null;
      state.btnName = {
        confirm: '',
        close: '',
      };
    }, 300);
  },
  // RESET_STATE(state) {
  //   const defaultState = DEFAULT_STATE_OBJECT['Modal']()
  //   for (let key in defaultState) {
  //     state[key] = defaultState[key]
  //   }
  // }
};
